export default __webpack_public_path__ + "static/media/alfonso.459c59e0.jpg";